/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {},
        heroImage: {},
        heroImageGroup: {
            marginBottom: 2
        },
        heroImageSkeleton: {
            marginBottom: 2
        },
        thumbnailImageGroup: {
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: 8,
            gap: 8
        },
        thumbnailImageItem: {
            width: {base: '85px'},
            borderStyle: 'solid',
            _focus: {
                boxShadow: 'outline'
            },
            _focusVisible: {
                outline: 0
            }
        },
        thumbnailImageSkeleton: {
            marginRight: 2,
            width: [20, 20, 24, 24]
        },
        swiper: {
            'swiper-slide-thumb-active': {
                backgroundColor: 'fullBlack'
            },
            'swiper-pagination-bullet': {
                width: '20px',
                height: '2px',
                backgroundColor: 'white',
                borderRadius: '2px',
                margin: '0 4px',
                opacity: 'initial'
            }
        },
        badgeGroupPDP: {
            position: {base: 'absolute', md: 'none', lg: 'none'},
            top: {base: '0', md: 'none', lg: 'none'},
            left: {base: '20px', md: '10px', lg: 'none'},
            margin: {base: '10px', md: 'none', lg: 'none'},
            paddingLeft: '4px',
            paddingRight: '4px'
        },
        badgeCustomStyle: {
            bg: 'white',
            paddingLeft: '4px',
            paddingRight: '4px',
            textTransform: 'none',
            fontWeight: 'normal',
            fontSize: '11px'
        },
        linkedProductSets: {
            position: 'absolute',
            bottom: 0,
            right: 0,
            left: 0,
            p: ['22px', '22px', '44px', '44px'],
            textAlign: 'center'
        },
        linkedProductSetsTitle: {
            color: 'white',
            fontSize: ['53px', '53px', '106px', '106px'],
            fontWeight: 400,
            textTransform: 'uppercase',
            mb: ['12px', '12px', '24px', '24px']
        }
    },
    sizes: {
        sm: {
            heroImageSkeleton: {
                maxWidth: ['none', 'none', 'none', '500px']
            },
            heroImage: {
                maxWidth: ['none', 'none', 'none', '500px']
            }
        },
        md: {
            heroImageSkeleton: {
                maxWidth: ['none', 'none', 'none', '680px']
            },
            heroImage: {
                maxWidth: ['none', 'none', 'none', '680px']
            }
        }
    },
    defaultProps: {
        size: 'md'
    },
    parts: ['container', 'heroImageGroup', 'heroImage', 'heroImageSkeleton', 'thumbnailImageGroup']
}
